import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  CustomFieldDetailMatchParams,
  customFieldDetailRouteProps,
} from 'src/navigation/routeProps'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCustomFieldIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<CustomFieldDetailMatchParams>(
      backgroundLocation.pathname,
      customFieldDetailRouteProps,
    ) as match<CustomFieldDetailMatchParams>
    return mtch?.params.customFieldId
  },
)
